(function () {
    const headerTop = document.querySelector('.header-top');
    if(!headerTop) return;

    let announcementBarHeight = 0;
    let productHeaderHeight = 0;
    const announcementBar = document.querySelector('.anno-bar-wrapper');
    const signupPopup = document.querySelector('.section-sign-up-popup');
    let headerTopHeight = headerTop.offsetHeight;
    if(announcementBar) {
        announcementBarHeight = announcementBar.offsetHeight;
    }

    const productHeader = document.querySelector('.product-header-desktop');
    if(productHeader) {
        productHeaderHeight = productHeader.offsetHeight;
    }

    const mainProduct = document.querySelector('.product-page.main-product');

    let previousScrollPosition = window.scrollY;
    let isHeaderFixed = false;
    let isHeaderEnabled = false;
    let signupPopupTopMargin = announcementBarHeight + headerTopHeight;
    let errorPopups = [];

    let handleScroll = function(e) {
        let scrollPosition = window.scrollY;
        if(scrollPosition < 0) {
            scrollPosition = 0;
        }

        if(scrollPosition <= announcementBarHeight) {
            headerTop.style.top = announcementBarHeight + 'px';
            headerTop.classList.remove('fixed');
            headerTop.classList.remove('transitions');
            isHeaderFixed = false;
        } else {
            if(scrollPosition >= announcementBarHeight + headerTopHeight && !isHeaderFixed) {
                requestAnimationFrame(function() {
                    headerTop.style.top = '0px';
                    headerTop.style.transform = 'translateY(0)';
                    requestAnimationFrame(function() {
                        headerTop.classList.add('fixed');
                        isHeaderFixed = true;
                        requestAnimationFrame(function() {
                            headerTop.classList.add('transitions');
                        });
                    });
                });
            }
        }

        if(isHeaderFixed && scrollPosition > previousScrollPosition) {
            headerTop.style.transform = 'translateY(0)';
            isHeaderEnabled = false;
        } else {
            headerTop.style.transform = 'translateY(0)';
            isHeaderEnabled = true;
        }

        if(signupPopup) {
            let translateY = signupPopupTopMargin - scrollPosition;
            if(translateY < 0) {
                translateY = 0;
            }
            if(isHeaderEnabled && translateY < headerTopHeight) {
                translateY = headerTopHeight;
            }
            signupPopup.style.transform = 'translateY('+translateY+'px)';
        }

        errorPopups = document.querySelectorAll('.error-popup');
        errorPopups.forEach((popup) => {
            let translateY = signupPopupTopMargin - scrollPosition;
            if(translateY < 0) {
                translateY = 0;
            }
            if(isHeaderEnabled && translateY < headerTopHeight) {
                translateY = headerTopHeight;
            }
            popup.style.transform = 'translateY('+translateY+'px)';
        });

        if(productHeader) {
            if(scrollPosition >= headerTopHeight + announcementBarHeight || isHeaderFixed) {
                productHeader.classList.add('fixed');
                if(mainProduct) {
                    mainProduct.style.paddingTop = productHeaderHeight + 'px';
                }
                if(isHeaderEnabled && previousScrollPosition >= scrollPosition) {
                    productHeader.style.transform = 'translateY('+headerTopHeight+'px)';
                } else {
                    productHeader.style.transform = 'translateY(0)';
                }
                requestAnimationFrame(function() {
                    productHeader.classList.add('transitions');
                });
            } else {
                productHeader.classList.remove('transitions');
                productHeader.classList.remove('fixed');
                if(mainProduct) {
                    mainProduct.style.paddingTop = '0';
                }
                productHeader.style.transform = 'translateY(0)';
            }
        }

        previousScrollPosition = scrollPosition;
    }

    let handleResize = function(e) {
        if(announcementBar) {
            announcementBarHeight = announcementBar.offsetHeight;
        }
        if(headerTop) {
            headerTopHeight = headerTop.offsetHeight;
        } 
        if(productHeader) {
            productHeaderHeight = productHeader.offsetHeight;
        }

        signupPopupTopMargin = announcementBarHeight + headerTopHeight;

        throttleScroll(e);
    }

    let throttle = function (callback) {
        var active = false; // a simple flag
        var evt; // to keep track of the last event
        var handler = function () { // fired only when screen has refreshed
            active = false; // release our flag 
            callback(evt);
        }
        return function handleEvent(e) { // the actual event handler
            evt = e; // save our event at each call
            if (!active) { // only if we weren't already doing it
                active = true; // raise the flag
                requestAnimationFrame(handler); // wait for next screen refresh
            };
        }
    }

    const throttleScroll = throttle(handleScroll);
    const throttleResize = throttle(handleResize); 

    window.addEventListener('scroll', throttleScroll);
    window.addEventListener('resize', throttleResize);

    handleResize();
})();